import type { FetchFilterOptions, FilterQueryParams } from '@/lib/api/types/filters';
import type { NewFilters } from '@/lib/filters/types';

/**
 * Tree selects keep parent values for checkbox state, but the API expects only
 * leaf selections.
 */
function normalizeFiltersForApi(filters: NewFilters): NewFilters {
  return {
    ...filters,
    disposers: filters?.disposers?.filter((value) => String(value).includes('-')),
    processes: filters?.processes?.filter((value) => typeof value === 'number'),
  };
}

function removeEmptyFilters(filters: NewFilters): Partial<NewFilters> {
  return Object.fromEntries(
    Object.entries(normalizeFiltersForApi(filters))?.filter(([, value]) => {
      if (value == null) return false;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'string') return value.trim().length > 0;
      return true;
    })
  ) as Partial<NewFilters>;
}

export function createFilterParams(
  { filters, group, lang }: FilterQueryParams,
  { includeLang = true }: FetchFilterOptions = {}
) {
  return {
    group,
    ...(includeLang ? { lang } : {}),
    filters: JSON.stringify(removeEmptyFilters(filters)),
  };
}
